import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { ReassignInvestigationCommand } from './reassign-investigation.command';

@Injectable({ providedIn: 'root' })
export class ReassignInvestigationUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(command: ReassignInvestigationCommand): Observable<void> {
    return this._repository.singleReassign(command.investigationId, {
      newPrimaryUserId: command.newPrimaryUserId,
      reason: command.reason,
    });
  }
}
